import React from 'react'
import tiag from "../images/tiag.png"

function Tiag() {
  return (
    <div className='py-[3rem] mt-[1rem]'>
        <div className='w-[10rem] mx-auto'>
            <img src={tiag} alt="" />
        </div>
    </div>
  )
}

export default Tiag